import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { resetEdit, resetFormStatus, resetQuizzesData, selectedMenu, setEdit } from "../../redux/actions/actions";
import FormPartOne from "./FormPartOne";
import FormPartTwo from "./FormPartTwo";

export default function CustomAddQuizzes() {
    const [nextClicked, setNextClicked] = useState(false)
    const headerText = useSelector(state => state.headerState.headerText)
    const editState = useSelector(state => state.editState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const location = useLocation()
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(selectedMenu(2))
        if (!editState.flag && location.state?.id) {
            dispatch(setEdit(location.state.id))
        }
        return () => {
            dispatch(resetFormStatus())
            dispatch(resetEdit())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (editState.flag && location.state?.nextClicked) {
            setNextClicked(true)
        }
        // eslint-disable-next-line
    }, [editState.flag])

    const backClickHandler = () => {
        let quizId = localStorage.getItem('quizId')
        dispatch(setEdit(quizId.toString()))
        dispatch(resetQuizzesData())
        setNextClicked(false)
    }


    return (
        <Box
            flexGrow='1'
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '90%', '90%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex' mb='2rem' flexDirection='column'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} mb='1'>{headerText}</Text>
                <Box width={['100%', '100%', '100%', '90%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex'>

                    <Box style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '90%' }}>
                        <Box width={['100%', '100%', '90%', '90%', '85%']} d='flex' justifyContent='space-between' mb='1rem' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['12px', '13px', '14px', '14px']} >
                            <Box width='49%' flexDirection='column'>
                                <Text mb='1' color={nextClicked ? '#70b259' : '#222222'}>1. ASSESSMENT INTRODUCTION</Text>
                                <Box height='1' width='100%' bg='#70b259'></Box>
                            </Box>
                            <Box width='49%' flexDirection='column'>
                                <Text mb='1' color={nextClicked ? "#222222" : '#999999'}>2. ASSESSMENT SETUP</Text>
                                <Box height='1' width='100%' bg={nextClicked ? '#70b259' : '#999999'}></Box>
                            </Box>
                        </Box>
                        {
                            nextClicked ? <FormPartTwo backClickHandler={backClickHandler} /> : <FormPartOne setNextClicked={setNextClicked} />
                        }
                        {/* {formStatus.error &&
                            <Text
                                fontSize='sm'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                color='red.500'
                            >
                                {formStatus.error}
                            </Text>} */}
                    </Box>

                </Box>
            </Box >
        </Box >
    )
}